import type { ReactNode } from 'react';

/** Aide secondaire native, repliée par défaut et utilisable au clavier comme au toucher.
 * Les montants et les états incomplets restent hors de ce volet, visibles dans la carte. */
export function FinanceExplanation({
  title = 'Comprendre les chiffres',
  children,
}: {
  readonly title?: string;
  readonly children: ReactNode;
}): React.JSX.Element {
  return (
    <details className="finance-explanation">
      <summary>{title}</summary>
      {children}
    </details>
  );
}
